import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useParams } from 'react-router-dom'

import { ReactComponent as Checkmark } from '../../../../assets/icons/checkmark.svg'
import { ReactComponent as LinkIcon } from '../../../../assets/icons/link.svg'
import {
    INLUDataExample,
    useNLUDataStore,
} from '../../../../stores/nluDataStore'
import Bulb from '../../../Bulb/Bulb'

import styles from './intent-section.module.scss'

interface IIntentSectionProps {
    example: INLUDataExample
    examplesRef: React.RefObject<HTMLDivElement>
}

function IntentSection(props: IIntentSectionProps) {
    const { example, examplesRef } = props
    const { _id, intent } = example

    const { t } = useTranslation()

    const { tab } = useParams()

    const [{ intents, intentsStatus }, { editExampleIntent }] =
        useNLUDataStore()

    const [newIntent, setNewIntent] = useState(intent)

    const handleSubmitChangeIntent = (e: React.FormEvent) => {
        e.preventDefault()

        tab && editExampleIntent(tab, _id, newIntent)
    }

    const status =
        intentsStatus.find((intent) => intent.name === example.intent)?.used ||
        false

    return (
        <div className={styles.intentSection}>
            <div className={styles.intentSection__intent}>
                <Bulb
                    scrollWrapperRef={examplesRef}
                    status={status}
                    errorMessage={t('no_intent_used')}
                />
                <form
                    className={styles.intentSection__form}
                    onSubmit={handleSubmitChangeIntent}
                >
                    <input
                        list="intent"
                        name="intent"
                        value={newIntent}
                        onChange={(e) => setNewIntent(e.target.value)}
                        className={styles.intentSection__input}
                    />
                    <datalist id="intent">
                        {intents.map((intent) => (
                            <option key={intent} value={intent}>
                                {intent}
                            </option>
                        ))}
                    </datalist>
                    {intent === newIntent ? (
                        <Link
                            to={`/responses?search=${intent}`}
                            className={styles.intentSection__link}
                        >
                            <LinkIcon className={styles.intentSection__icon} />
                        </Link>
                    ) : (
                        <button
                            className={styles.intentSection__submitBtn}
                            type="submit"
                        >
                            <Checkmark className={styles.intentSection__icon} />
                        </button>
                    )}
                </form>
            </div>
        </div>
    )
}

export default IntentSection
